export default "__VITE_ASSET__DkThk7NJ__"